import type { ColumnTypeFn } from "../types";

export const relatedType: ColumnTypeFn = (value) => {
  if (value == null) return <span className="text-muted">-</span>;
  if (typeof value === "object" && value.str !== undefined) {
    if (value.url) {
      return <a href={value.url} className="rd-link">{value.str}</a>;
    }
    return <>{value.str}</>;
  }
  return <>{String(value)}</>;
};
